"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORE_BG_LIGHT = exports.STORE_BG = exports.DEFAULT_STORE_IMAGE = exports.AEM_URL = exports.StoreLocatorClosestText = exports.StoreLocatorThemeArray = exports.StoreLocatorThemeVariants = void 0;

var _const = require("../../const");

var StoreLocatorThemeVariants;
exports.StoreLocatorThemeVariants = StoreLocatorThemeVariants;

(function (StoreLocatorThemeVariants) {
  StoreLocatorThemeVariants["WHITE"] = "white";
  StoreLocatorThemeVariants["SEASHELL"] = "seashell";
  StoreLocatorThemeVariants["SEASHELL_ALT"] = "seashell-alt";
  StoreLocatorThemeVariants["MOCASSIN"] = "mocassin";
  StoreLocatorThemeVariants["MOCASSIN_ALT"] = "mocassin-alt";
  StoreLocatorThemeVariants["CLARET"] = "claret";
  StoreLocatorThemeVariants["BLACK"] = "black";
  StoreLocatorThemeVariants["IMAGE_LIGHT"] = "image-light";
  StoreLocatorThemeVariants["IMAGE_DARK"] = "image-dark";
})(StoreLocatorThemeVariants || (exports.StoreLocatorThemeVariants = StoreLocatorThemeVariants = {}));

var StoreLocatorThemeArray = Object.values(StoreLocatorThemeVariants);
exports.StoreLocatorThemeArray = StoreLocatorThemeArray;
var StoreLocatorClosestText;
exports.StoreLocatorClosestText = StoreLocatorClosestText;

(function (StoreLocatorClosestText) {
  StoreLocatorClosestText["TITLE"] = "we\u2019d love to";
  StoreLocatorClosestText["SUBTITLE"] = "see you in store!";
  StoreLocatorClosestText["BLOCK_LABEL"] = "your store";
  StoreLocatorClosestText["BLOCK_DETAILS"] = "view store details";
  StoreLocatorClosestText["DENIED_TITLE"] = "Where are you, beautiful?";
  StoreLocatorClosestText["DENIED_SUBTITLE"] = "Share your location to find the closest store.";
})(StoreLocatorClosestText || (exports.StoreLocatorClosestText = StoreLocatorClosestText = {}));

var AEM_URL = "https://dev.davidsbridal.com";
exports.AEM_URL = AEM_URL;
var DEFAULT_STORE_IMAGE = "".concat(_const.assetsUrl, "/default-store.png");
exports.DEFAULT_STORE_IMAGE = DEFAULT_STORE_IMAGE;
var STORE_BG = "".concat(_const.prodAssetsUrl, "/store-locator/closest-store-bg.jpg");
exports.STORE_BG = STORE_BG;
var STORE_BG_LIGHT = "".concat(_const.prodAssetsUrl, "/store-locator/closest-store-bg-white.jpg");
exports.STORE_BG_LIGHT = STORE_BG_LIGHT;